import React from 'react';

export default function Step1(props) {
  const { locations, standards, getStandard, setStandard, getLocation, setLocation } = props;
  const strings = window.themeStrings || {};

  return (
    <div className="form-body">
      <fieldset className="form-field">
      <legend className="form-legend">{strings.fit_finder_step1_select_standard}</legend>
      <div className="option-values option-values-one-line">
          {standards
            .map((standard, index) => {
              return (
                <div key={index} className="option-value">
                  <input
                    type="radio"
                    className="option-value-input"
                    id={`standard-${index}`}
                    name="standard"
                    value={standard.code}
                    checked={getStandard.code === standard.code}
                    onChange={() => setStandard(standard)} />
                  <label htmlFor={`standard-${index}`} className="option-value-name">{standard.label}</label>
                </div>
              )
            })
          }
        </div>
      </fieldset>
      <fieldset className="form-field">
      <legend className="form-legend">{strings.fit_finder_step1_select_location}</legend>
      <div className="option-values option-values-one-line">
          {locations
            .map((country, index) => {
              return (
                <div key={index} className="option-value">
                  <input
                    type="radio"
                    className="option-value-input"
                    id={`location-${index}`}
                    name="location"
                    value={country.code}
                    checked={getLocation.code === country.code}
                    onChange={() =>
                      setLocation(country)
                    } />
                  <label htmlFor={`location-${index}`} className="option-value-name">{country.label}</label>
                </div>
              )
            })
          }
        </div>
      </fieldset>
      <p className="ff-intro" dangerouslySetInnerHTML={{ __html: strings.fit_finder_step1_intro }} />
    </div>
  );
}